export default __webpack_public_path__ + "static/media/check.416baad6.svg";